import React from 'react';
import { Link } from 'react-router-dom';
type ButtonProps = {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline' | 'transparent';
  size?: 'sm' | 'md' | 'lg';
  href?: string;
  type?: 'button' | 'submit' | 'reset';
  className?: string;
  onClick?: () => void;
};
export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  href,
  type = 'button',
  className = '',
  onClick
}: ButtonProps) {
  const baseStyles = 'font-medium rounded-md transition-colors duration-200';
  const variantStyles = {
    primary: 'bg-primary hover:bg-primary-light text-white',
    secondary: 'bg-secondary hover:bg-secondary-light text-white',
    outline: 'bg-transparent border border-white text-white hover:bg-white/10',
    transparent: 'bg-transparent border border-white text-white hover:bg-white/10'
  };
  const sizeStyles = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2',
    lg: 'px-6 py-3 text-lg'
  };
  const buttonClasses = `${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${className}`;
  if (href) {
    return <Link to={href} className={buttonClasses} data-id="element-269">
        {children}
      </Link>;
  }
  return <button type={type} className={buttonClasses} onClick={onClick} data-id="element-270">
      {children}
    </button>;
}